import { API_PREFIX_DESTINATION_PATH } from "@/constants/prefix-path-api"
import { message } from "antd"
import { HttpClient } from "../../../../app/api/HttpClient"
import { FilterSearchParams } from "../../../../lib/external-components"

export const fetchDestinations = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "tour_v_2s",
    sort: "updatedAt:desc",
    filters: {},
    pagination: {
      pageSize: "20",
    },
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "populate") {
      params.populate = value
    } else if (key === "locale") {
      params.locale = value
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_DESTINATION_PATH}`, { params })
    return response
  } catch (error) {
    message.error("Không thể lấy danh sách destinations. Vui lòng thử lại.")
  }
}

export const fetchDestinationById = async (id: number | string) => {
  return await HttpClient.get(`${API_PREFIX_DESTINATION_PATH}/${id}`, {
    params: {
      populate: "tour_v_2s",
    },
  })
}

export const createDestination = async (data: { name: string; tourIds?: number[] }) => {
  const payload: any = { data: { name: data.name } }
  if (data.tourIds && data.tourIds.length > 0) {
    payload.data.tour_v_2s = data.tourIds
  }
  return await HttpClient.post(`${API_PREFIX_DESTINATION_PATH}`, payload)
}

export const updateDestination = async (id: number | string, data: { name: string; tourIds?: number[] }) => {
  const payload: any = { data: { name: data.name } }
  if (data.tourIds !== undefined) {
    payload.data.tour_v_2s = data.tourIds
  }
  return await HttpClient.put(`${API_PREFIX_DESTINATION_PATH}/${id}`, payload)
}

export const deleteDestination = async (id: number | string) => {
  return await HttpClient.delete(`${API_PREFIX_DESTINATION_PATH}/${id}`)
}

export const getDestinationById = async (id: number) => {
  return await HttpClient.get(`${API_PREFIX_DESTINATION_PATH}/${id}`)
}

// Assign tours to destination
export const assignToursToDestination = async (destinationId: number | string, tourIds: number[]) => {
  return await HttpClient.put(`${API_PREFIX_DESTINATION_PATH}/${destinationId}`, {
    data: {
      tour_v_2s: tourIds
    }
  })
}
